export const getNow = (): number => performance.now();
